import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { firebaseAuth, firebaseStorage } from '../firebase';

export const uploadService = {
  uploadImage: async (formDataOrFile) => {
    try {
      if (!firebaseAuth?.currentUser) {
        return { success: false, error: 'Non authentifié' };
      }
      if (!firebaseStorage) {
        return { success: false, error: 'Firebase Storage non configuré' };
      }

      let file = formDataOrFile;
      if (formDataOrFile instanceof FormData) {
        file = formDataOrFile.get('image');
      }
      if (!(file instanceof Blob)) {
        return { success: false, error: 'Fichier invalide' };
      }

      const uid = firebaseAuth.currentUser.uid;
      const ext = file.type?.split('/')?.[1] || 'bin';
      const filename = `${Date.now()}_${Math.random().toString(16).slice(2)}.${ext}`;
      const path = `uploads/images/${uid}/${filename}`;
      const storageRef = ref(firebaseStorage, path);
      await uploadBytes(storageRef, file);
      const imageUrl = await getDownloadURL(storageRef);

      return {
        success: true,
        imageUrl,
        filename,
      };
    } catch (error) {
      console.error('Erreur lors de l\'upload de l\'image:', error);
      return {
        success: false,
        error: error.message || 'Erreur lors de l\'upload de l\'image',
      };
    }
  },
};
